import React from 'react'
import '../styles/JoinUs.css'

export default function JoinUs() {
    return (
        <>
            <div className="joinUs">
                <div className="container">
                    <h3 className="title">Join us</h3>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="image">
                                <img src="./images/instructor.png" alt="instructor"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="join">
                                <h3>Become a Teacher</h3>
                                <p>
                                    Be one of our professional instructors ,
                                    just fill a simple application to apply our requirements
                                </p>
                                <button>Get application <i className="fas fa-angle-right" style={{fontSize:"13px"}}></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="animation-area">
                    <div className="box-area">
                        <img src="./images/1.png"/>
                        <img src="./images/2.png"/>
                        <img src="./images/3.png"/>
                        <img src="./images/4.png"/>
                        <img src="./images/5.png"/>
                        <img src="./images/6.png"/>
                        <img src="./images/7.png"/>
                        <img src="./images/8.png"/>
                        <img src="./images/9.png"/>
                        <img src="./images/10.png"/>
                        <img src="./images/11.png"/>
                        <img src="./images/12.png"/>
                    </div>
                </div>
            </div>   
        </>
    )
}
